import { useCallback } from 'react';
import { fieldTypes } from '../constants/app';
import { getParentLabelId } from '../utils/visibilityUtils';

export function useRequestFormInput(setFormState, visibleFields) {
  const handleInputChange = useCallback(
    (key: number, value: string, children?: []) => {
      setFormState((prev) => {
        const updated = {
          ...prev,
          [key]: {
            children:
              children && Array.isArray(children) && children.length > 0
                ? children
                : [],
            value,
          },
        };

        visibleFields.forEach((label) => {
          if (label.type === fieldTypes.sum) {
            const dependentFields = visibleFields.filter(
              (f) => getParentLabelId(f) === label.labelId
            );
            const sum = dependentFields.reduce((acc, f) => {
              const v = parseFloat(
                f.labelId === key ? value : updated[f.labelId]?.value || '0'
              );
              return acc + (isNaN(v) ? 0 : v);
            }, 0);
            updated[label.labelId] = {
              ...updated[label.labelId],
              value: sum,
            };
          }
        });

        return updated;
      });
    },
    [setFormState, visibleFields]
  );

  return { handleInputChange };
}
